<template>
    <div class="layout">
        <page-form ref="formDataName" :formData="formData" @onSubmit="reSearch"
                :needValidation="true"></page-form>
        <Table ref="moTable" border :columns="columns" :data="tableData" :loading="loading" @on-selection-change="selectionChange" size="small">
            <div slot="header">
                &nbsp;&nbsp;<Button type="primary" :disabled="comfirmIds.length === 0" :loading="comfirmLoading" @click="comfirm">{{ $t('vendorBadRecord.t1') }}</Button>
                <Button style="margin-left:10px;" type="primary" @click="exportExcel">{{ $t('vendorBadRecord.t2') }}</Button>
                <div style="float:right; display:flex; align-items:center;">
                  <Icon type="ios-circle-filled" size="27" color="#DCDCDC" style="margin-right:10px;"></Icon>
                  <span style="margin-right:30px;">{{ $t('vendorBadRecord.t3') }}</span>
                  <Icon type="ios-circle-filled" size="27" color="#666666" style="margin-right:10px;"></Icon>
                  <span style="margin-right:30px;">{{ $t('vendorBadRecord.t4') }}</span>
                </div>
            </div>
        </Table>
        <pagination :total="total" :currentPage="current" :pageSize="pageSize" show-sizer @on-current-page-change="handleChange" @on-page-size-change="handlePageChange"></pagination>
    </div>
</template>
  <script>
  import moment from 'moment';
  import pageForm from '@/components/awesome/page/query/index';
  import pagination from '@/components/awesome/page/pagination/index';
  import axios from 'axios';
  import { qmsApiSwitch, getOrgCode } from '@/utils/tool';
  export default {
    name: 'vendorBadRecord',
    components: {
      pageForm,
      pagination
    },
    data() {
      return {
        supplierInfo: {}, // 供应商baseInfo
        comfirmIds: [],
        comfirmLoading: false,
        selection: [],
        orgId: '',
        tableData: [],
        loading: false,
        current: 1,
        pageSize: 10,
        total: 0,
        formData: {
          row: 2,
          items: [
            {
                value: '',
                field: 'organizationCode',
                disabled: false,
                validators: {
                    required: {
                        required: true,
                        message: this.$t('vendorBadRecord.t5')
                    }
                },
                layout: {
                    span: 8,
                    offset: 0,
                    row: 1
                },
                methods: {
                    change: (val) => {
                        console.log('val:', val); // undefined
                        /** 获取erpId-->orgId */
                        this.orgId = this.formData.items[0].value;
                        console.log('this.formData.items[0].value:', this.formData.items[0].value);
                        console.log('this.orgId:', this.orgId);
                    }
                },
                options: {
                    multiple: false,
                    values: []
                },
                type: 'select',
                placeholder: '',
                title: this.$t('vendorBadRecord.t6')
            },
            {
                value: '',
                field: 'itemCode',
                layout: {
                    span: 8,
                    offset: 0,
                    row: 1
                },
                options: {
                    rows: 1
                },
                type: 'text',
                title: this.$t('vendorBadRecord.t7')
            },
            {
                value: new Date(moment().subtract(7, 'days').format('YYYY-MM-DD')),
                field: 'checkedDateBegin',
                type: 'datePicker',
                title: this.$t('vendorBadRecord.t8'),
                style: 'width: 100%;',
                layout: {
                    row: 1,
                    span: 8,
                    offset: 0
                },
                options: {
                  type: 'date',
                  format: 'yyyy-MM-dd'
                },
                validators: {
                    required: {
                        required: true,
                        message: this.$t('vendorBadRecord.t9')
                    }
                },
                isDouble: true
            },
            {
                hide: true,
                value: new Date(),
                field: 'checkedDateEnd',
                type: 'datePicker',
                title: '',
                style: 'width: 100%;',
                layout: {
                    row: 1,
                    span: 8,
                    offset: 0
                },
                options: {
                  type: 'date',
                  format: 'yyyy-MM-dd'
                },
                validators: {
                    required: {
                        required: true,
                        message: this.$t('vendorBadRecord.t10')
                    }
                }
            },
            {
                value: 'N',
                field: 'confirmFlag',
                disabled: false,
                layout: {
                    span: 8,
                    offset: 0,
                    row: 2
                },
                options: {
                    multiple: false,
                    values: [
                        {
                            label: this.$t('vendorBadRecord.t1'),
                            value: 'Y'
                        },
                        {
                            label: this.$t('vendorBadRecord.t3'),
                            value: 'N'
                        }
                    ]
                },
                type: 'select',
                title: this.$t('vendorBadRecord.t11')
            }
          ]
        },
        columns: [
            {
                type: 'selection',
                width: 40,
                align: 'center'
            },
            {
                title: this.$t('vendorBadRecord.t12'),
                width: 40,
                align: 'center',
                render: (h, params) => {
                    return h('Icon', {
                        props: {
                            type: 'ios-circle-filled',
                            size: 27,
                            color: '#666666'
                        },
                        style: {
                          cursor: params.row.CONFIRM_FLAG === 'Y' ? 'pointer' : 'not-allowed',
                          color: params.row.CONFIRM_FLAG === 'Y' ? '#666666' : '#DCDCDC',
                          textAlign: 'left'
                        },
                        nativeOn: {
                            click: () => {
                                if (params.row.CONFIRM_FLAG === 'Y') {
                                  // this.printMo(params.row.makeOrderNum, false);
                                }
                            }
                        }
                    });
                }
            },
            {
                title: this.$t('vendorBadRecord.t13'),
                key: 'SUPPLIER_CODE',
                align: 'center',
                minWidth: 90,
                render: (h, params) => {
                    return h('div', {
                        style: { textAlign: 'left' }
                    }, [
                        h('span', {}, params.row.SUPPLIER_CODE)
                    ]);
                }
            },
            {
                title: this.$t('vendorBadRecord.t7'),
                key: 'CODE',
                align: 'center',
                minWidth: 120,
                render: (h, params) => {
                    return h('div', {
                        style: { textAlign: 'left' }
                    }, [
                        h('span', {}, params.row.CODE)
                    ]);
                }
            },
            {
                title: this.$t('vendorBadRecord.t14'),
                key: 'BILL_TYPE_DESC',
                align: 'center',
                minWidth: 120,
                render: (h, params) => {
                    return h('div', {
                        style: { textAlign: 'left' }
                    }, [
                        h('span', {}, params.row.BILL_TYPE_DESC)
                    ]);
                }
            },
            {
                title: this.$t('vendorBadRecord.t15'),
                key: 'EXAMINED_NO',
                align: 'center',
                minWidth: 150,
                render: (h, params) => {
                    return h('div', {
                        style: { textAlign: 'left' }
                    }, [
                        h('span', {}, params.row.EXAMINED_NO)
                    ]);
                }
            },
            {
                title: this.$t('vendorBadRecord.t16'),
                key: 'CHECKED_DATE_STRING',
                align: 'center',
                width: 130
            },
            {
                title: this.$t('vendorBadRecord.t17'),
                key: 'NG_LEVEL',
                align: 'center',
                minWidth: 60
            },
            {
                title: this.$t('vendorBadRecord.t18'),
                key: 'PROBLEM_DESC',
                align: 'center',
                minWidth: 300,
                render: (h, params) => {
                  return h('Tooltip', {
                    props: {
                      content: params.row.PROBLEM_DESC,
                      placement: 'top'
                    },
                    style: { textAlign: 'left' },
                    class: 'm-tooltip-overflow'
                  }, params.row.PROBLEM_DESC);
                }
            }
        ],
        mdmCode: '',
        orgList: [],
      };
    },
    methods: {
      reSearch () {
        let start = this.getFormDataItemVal(this.formData.items, 'checkDateStart');
        let end = this.getFormDataItemVal(this.formData.items, 'checkDateEnd');
        if (moment(end).subtract('6', 'M').format('x') > moment(start).format('x')) {
          this.$Modal.error({
              content: this.$t('vendorBadRecord.t19')
          });
        } else {
          this.loading = true;
          axios.get(qmsApiSwitch(this, '/qms2gsc/IqcOutgoing/QueryIncomingNgListForeign', getOrgCode(this.orgList, this.orgId)), {
            params: {
              pageIndex: this.current,
              pageSize: this.pageSize,
              orgId: this.orgId,
              itemCode: this.getFormDataItemVal(this.formData.items, 'itemCode'),
              checkedDateBegin: this.getFormDataItemVal(this.formData.items, 'checkedDateBegin'),
              checkedDateEnd: this.getFormDataItemVal(this.formData.items, 'checkedDateEnd'),
              confirmFlag: this.getFormDataItemVal(this.formData.items, 'confirmFlag'),
              supplierCode: this.mdmCode,
              language: this.$i18n.locale
            }
          })
          .then((res) => {
            this.loading = false;
            let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
            if (resp.IsSucess) {
              this.tableData = resp.MainResultData.DATA;
              this.total = resp.MainResultData.TOTAL;
            } else {
              this.$Modal.error({
                  title: this.$t('common.warn'),
                  content: this.$t('common.error1')
              });
            }
          })
          .catch(() => {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
          });
        }
      },
      handleChange (page) {
        this.current = page;
        this.$refs.formDataName.$children[0].$children[0].$children[0].validate((valid) => {
            if (valid) {
              this.reSearch();
            }
        });
      },
      handlePageChange (pageSize) {
        this.pageSize = pageSize;
        this.$refs.formDataName.$children[0].$children[0].$children[0].validate((valid) => {
            if (valid) {
              this.reSearch();
            }
        });
      },
      selectionChange (selection) {
        this.comfirmIds = [];
        this.selection = selection;
        this.selection.map((item) => {
          if (item.CONFIRM_FLAG === 'N') {
            this.comfirmIds.push(item.ID);
          }
        });
      },
      exportExcel () {
        this.$refs.formDataName.$children[0].$children[0].$children[0].validate((valid) => {
            if (valid) {
              window.open(`/gscint/supplier/badResume/exportIncomingNgList?supplierCode=${this.mdmCode}&orgId=${this.orgId}&itemCode=${this.getFormDataItemVal(this.formData.items, 'itemCode')}&checkedDateBegin=${this.getFormDataItemVal(this.formData.items, 'checkedDateBegin')}&checkedDateEnd=${this.getFormDataItemVal(this.formData.items, 'checkedDateEnd')}&confirmFlag=${this.getFormDataItemVal(this.formData.items, 'confirmFlag')}&language=${this.qmsLanguageChange2()}`);
            }
        });
      },
      comfirm () {
        this.comfirmLoading = true;
        axios.get(this.qmsApiSwitch(this, '/qms2gsc/IqcOutgoing/ConfirmIncomingNgForeign', getOrgCode(this.orgList, this.orgId)), {
          params: {
            orgId: this.orgId,
            ids: this.comfirmIds.toString(),
            comfirmUser: this.vendorCode,
            supplierCode: this.mdmCode,
            language: this.$i18n.locale
          }
        })
        .then((res) => {
          this.comfirmLoading = false;
          let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
          if (resp.IsSucess) {
            this.$Modal.success({
                content: this.$t('vendorBadRecord.t20')
            });
            this.reSearch();
            this.comfirmIds = [];
          } else {
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
          }
        })
        .catch(() => {
          this.comfirmLoading = false;
        });
      }
    },
    mounted () {
        this.queryVendorAndMdm(this.vendorCode, (data) => {
            this.mdmCode = data;
        });
        this.getSRMInvLovListNew((data) => {
            this.orgList = data;
            data.forEach((item) => {
                item.value = item.erpOrgId;
                item.label = item.organizationName;
            });
            this.getFormDataItemObj(this.formData.items, 'organizationCode').options.values = data;
        });
    }
  };
  </script>
  <style scoped lang="less">
  .layout {
    padding: 10px;
    background: #FFF;
  }
  </style>